export default __webpack_public_path__ + "static/media/kpi_icon_w.9f422869.png";